import React, { Component } from 'react';
import { compose } from 'redux';

import './TransactionGroup.scss';

import AutomaticTransactionList from '../AutomaticTransactionList/AutomaticTransactionList';
import Button from '../../Shared/Button/Button';
import { connect } from 'react-redux';
import { getHasCollegeOnly } from '../../../redux/modules/productTypes/productType.selectors';
import { IRA_AUTO_MAX, RMD } from '../../../settings/settings';
import If from '../../Shared/If/If';
import {
  isCustomerWebViewEnabled,
  isSalesforceRep,
} from '../../../redux/modules/authentication/authentication.module.selectors';
import { getOWNRAutoMaxFunds } from '../../../redux/modules/shoppingCart/shoppingCart.selectors';
import {
  getUserAutoMaxPOAs,
  getUserHasAutoMaxPOAs,
} from '../../../redux/modules/automaticInvestments/automaticInvestments.selectors';

export class TransactionGroup extends Component {
  render() {
    const {
      isSalesforceRep,
      customerWebViewEnabled,
      ownsIRAs,
      buttonText,
      funds,
      getHasCollegeOnly,
      subtitle,
      title,
      link,
      type,
      showButton = true,
    } = this.props;
    //TODO: the link for RMD should be based on appendBasePath -> find a way to redirect to correct webpage using
    //that function
    return (
      <div
        className="transaction-group college-branded-progress-border"
        id={`transaction-group-${type}`}
      >
        <div className="transaction-group-header-and-content">
          <div className="transaction-group-group-information-container">
            <div className="transaction-group-title">{title}</div>
            <div className={'transaction-group-subtitle'}>{subtitle}</div>
            <If
              test={
                (type !== IRA_AUTO_MAX || ownsIRAs) &&
                !(!customerWebViewEnabled && isSalesforceRep)
              }
            >
              <If test={!!showButton}>
                <a href={link} tabIndex={-1}>
                  <Button
                    id={`step-${type}-button`}
                    className={`${
                      getHasCollegeOnly
                        ? 'transaction-group-add-new-college-button'
                        : type !== RMD && 'transaction-group-add-new-button'
                    } college-branded-progress-button e2e-step-${type}-button ${
                      type === RMD && 'btn-rmd-transaction-button'
                    }`}
                    buttonType="primary"
                    type="button"
                    disabled={false}
                    onClick={() => {}}
                  >
                    {buttonText}
                  </Button>
                </a>
              </If>
            </If>
          </div>
          <div className="transaction-group-transaction-list-container">
            <AutomaticTransactionList
              buttonText={buttonText}
              funds={funds}
              link={link}
              title={title}
              ownsIRAs={ownsIRAs}
              type={type}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isSalesforceRep: isSalesforceRep(state),
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    getHasCollegeOnly: getHasCollegeOnly(state),
    autoMaxOwnedIRATransactions: getOWNRAutoMaxFunds(state),
    autoMaxPOAIRATransactions: getUserAutoMaxPOAs(state),
    hasAutoMaxPOAs: getUserHasAutoMaxPOAs(state),
  };
};

export default compose(connect(mapStateToProps))(TransactionGroup);
